const wxAuthorization = {
    path: 'wxAuthorization',
    component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/yftWeChat/found/wxAuthorization'], resolve)
  }
  
  export default wxAuthorization